<template>
  <div class="landing-container">
    <header class="landing-header">
      <div class="header-content">
        <div class="logo">
          <img src="https://cdn1.ferryhopper.com/img/ferryhopper-logo-small.svg" alt="Ferryhopper Logo" />
        </div>
        <div class="nav-menu">
          <button class="menu-toggle" @click="toggleMenu">
            <i class="fa fa-bars"></i>
          </button>

          <div class="menu-dropdown" :class="{ 'menu-active': isMenuOpen }">
            <router-link to="/" class="menu-item">Home</router-link>
            <a href="https://partners.ferryhopper.com/affiliates" target="_blank" class="menu-item">Contact us</a>
          </div>
        </div>
      </div>
    </header>


    <main class="landing-content">
      <div class="content-wrapper">
        <div class="two-column-container">
          <div class="welcome-section">
            <h1>Welcome</h1>
            <p>With our affiliate program you can monetize your website or blog content by recommending the best ferry
              booking platform out there.</p>

            <h2>Want to join?</h2>
            <p>Please <a href="https://partners.ferryhopper.com/affiliates" class="email-link">submit your request</a> and
              our team will get back to you soon. We have worked out the complicated parts
              for you, so the integration process is super easy.</p>
          </div>

          <div class="login-section">
            <div class="login-card">
              <h2>Already a member?</h2>
              <p>Enter your username and password to log in to your account.</p>

              <form @submit.prevent="login" class="login-form">
                <div class="form-group">
                  <input type="text" v-model="username" placeholder="username@ferryhopper.com" class="form-input"
                    required>
                </div>

                <div class="form-group">
                  <input type="password" v-model="password" placeholder="••••••••" class="form-input" required>
                </div>

                <button type="submit" class="login-button" :disabled="isWaiting">Log in <i class="fa fa-spinner fa-spin"
                    v-if="isWaiting"></i></button>
              </form>

              <p v-if="isSessionExpired && (!loginError)">
                <small>Your session has expired. Please sign in again.</small>
              </p>

              <p v-if="loginError">
                <small>{{ loginErrorMessage }}</small>
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>

    <footer class="landing-footer"></footer>
  </div>

</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import ApiGateway from '../../../services/ApiGateway'

const store = useStore()
const router = useRouter()

let username = localStorage.getItem('fh_user_name') || ''
let password = ''
const isWaiting = ref(false);
const isMenuOpen = ref(false);
const loginError = ref(false);
const loginErrorMessage = ref('');

const isSessionExpired = store.getters['authentication/isSessionExpired']

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
}

const login = async () => {
  isWaiting.value = true
  loginError.value = false

  try {
    const { data: loginData } = await ApiGateway.loginCheck(username, password);
    if (!loginData || !loginData.user) {
      throw new Error('Unable to contact server. Please try again later.');
    }
    await store.dispatch('authentication/logInAction', loginData)
    await router.push('dashboard/overview')
  } catch (error) {
    loginError.value = true
    loginErrorMessage.value = error && error.message || 'An unknown error has occured';
  } finally {
    isWaiting.value = false
  }
}
</script>

<style scoped>
.welcome-section {
  flex: 1;
}


.two-column-container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  gap: 4rem;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .two-column-container {
    flex-direction: column;
    gap: 2rem;
  }
}


.login-section {
  width: 350px;
}

@media (max-width: 768px) {
  .login-section {
    width: 100%;
  }
}

.login-card {
  background: transparent;
}

.login-card h2 {
  color: #333;
  margin-bottom: 0.5rem;
}

.login-card p {
  color: #666;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
